import React from 'react';
import { connect } from 'react-redux'

import Icon from '@mdi/react';
import { mdiClipboardEditOutline } from '@mdi/js';

import { _ } from '../../functions/translator'

class UpdateButton extends React.Component{
          
    handleClick = () => {
        let url = window.location.origin + '/update-card?project_id=' + window.project_id + '&cards_group_id='
        this.props.closableCardsGroups.forEach((cardsGroupId, index) => {
            url += cardsGroupId.toString()
            if (index < this.props.closableCardsGroups.length - 1) {
                url += ','
            }
        });
        window.open(url)
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiClipboardEditOutline } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Revisar Protocolo(s)') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

export default connect(mapStateToProps)(UpdateButton)